import { useBancolleRepository, BancolleRepository } from './bancolleRepository';
import { BlacklistRepository, useBlacklistRepository } from './blackProgramsRepository';
import { useGenreRepository, GenreRepository } from './genreRepository';
import { useIchioshiRepository, IchioshiRepository } from './ichioshiRepository';
import { useMaintenanceRepository, MaintenanceRepository } from './maintenanceRepository';
import { useMylistRepository, MylistRepository } from './mylistRepository';
import { useNewsRepository, NewsRepository } from './newsRepository';
import { useOtherRepository, OtherRepository } from './otherRepository';
import { useScheduleRepository, ScheduleRepository } from './scheduleRepository';
import { useSearchRepository, SearchRepository } from './searchRepository';
import { useSurveyRepository, SurveyRepository } from './surveyRepository';
import { useUserRepository, UserRepository } from './userRepository';

// 全てのリポジトリを紐付ける
export type Repositories = {
  bancolle: BancolleRepository;
  genre: GenreRepository;
  ichioshi: IchioshiRepository;
  maintenance: MaintenanceRepository;
  news: NewsRepository;
  schedule: ScheduleRepository;
  survey: SurveyRepository;
  user: UserRepository;
  mylist: MylistRepository;
  search: SearchRepository;
  blacklist: BlacklistRepository;
  other: OtherRepository;
};

// 個別のリポジトリを管理する配列
const repositories = {
  bancolle: useBancolleRepository(),
  genre: useGenreRepository(),
  ichioshi: useIchioshiRepository(),
  maintenance: useMaintenanceRepository(),
  news: useNewsRepository(),
  schedule: useScheduleRepository(),
  survey: useSurveyRepository(),
  user: useUserRepository(),
  mylist: useMylistRepository(),
  search: useSearchRepository(),
  blacklist: useBlacklistRepository(),
  other: useOtherRepository(),
} as Repositories;

// getを使うと呼びたいリポジトリを指定できる
export const RepositoryFactory = {
  get: (name: keyof Repositories): Repositories[keyof Repositories] => repositories[name],
};
